export default {"src":"/_next/static/media/debt-and-cash-management.8b82c0f9.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};